// extracted by mini-css-extract-plugin
export default {"background":"verify_background__fAwBq"};